import * as React from "react";
import Select from "react-select";
import BooleanButton from "../button/booleanButton";
import { selectTheme } from "../select/selectTheme";
import "./selectAndPostitionInput.css";
export function SelectAndPositionInput(props) {
    const [selectedOption, setSelectedOption] = React.useState(null);
    const [verticalAlignment, setVerticalAlignment] = React.useState(false);
    const selectedName = React.useRef(null);
    const lastMousePosX = React.useRef(0);
    const lastMousePosY = React.useRef(0);
    const [shiftX, setShiftX] = React.useState(0);
    const [shiftY, setShiftY] = React.useState(0);
    const [isDragging, setDragging] = React.useState(false);
    React.useEffect(() => {
        props.onChange({
            resourceUrl: selectedOption,
            resourceName: selectedName.current,
            shiftX,
            shiftY,
            alignment: verticalAlignment ? 'vertical' : 'horizontal',
        });
    }, [selectedOption, shiftX, shiftY]);
    window.onpointerdown = (event) => {
        if (event.target.id === 'resource-draggable') {
            lastMousePosX.current = event.clientX;
            lastMousePosY.current = event.clientY;
            setDragging(true);
        }
    };
    window.onpointerup = (event) => {
        setDragging(false);
    };
    window.onmousemove = (event) => {
        if (!isDragging)
            return;
        setShiftX(-lastMousePosX.current + event.clientX);
        setShiftY(-lastMousePosY.current + event.clientY);
    };
    return (React.createElement("div", null,
        React.createElement(Select, { theme: selectTheme, placeholder: "Wybierz zas\u00F3b", options: props.params.options.map((option) => ({
                label: option.name,
                value: option.urlToResource,
            })), onChange: (newValue) => {
                selectedName.current = newValue.label;
                setSelectedOption(newValue.value);
            } }),
        "Kliknij i przytrzymaj zas\u00F3b by go przemie\u015Bci\u0107",
        React.createElement(BooleanButton, { label: "Format pionowy", defaultState: false, onClick: setVerticalAlignment }),
        React.createElement("div", { className: "resource-and-image-container" },
            React.createElement("img", { src: `../../assets/images/example-${verticalAlignment ? "vertical" : "horizontal"}.jpg`, height: "200" }),
            React.createElement("div", { className: "resource-on-image-container", style: {
                    left: shiftX + 'px',
                    top: shiftY + 'px'
                } }, selectedOption && (React.createElement("img", { src: selectedOption, height: "210", onDragStart: (event) => event.preventDefault(), id: "resource-draggable" }))))));
}
